<template>
  <div class="tab-bar">
    <router-link to="/" class="tab-item" :class="{ active: activeNavItem === 'home' }" @click="setActive('home')">
      <i class="fas fa-home tab-icon"></i>
      <span>首页</span>
    </router-link>
    <router-link to="/dictionary" class="tab-item" :class="{ active: activeNavItem === 'dictionary' }"
      @click="setActive('dictionary')">
      <i class="fas fa-book tab-icon"></i>
      <span>词典</span>
    </router-link>
    <router-link to="/practice" class="tab-item" :class="{ active: activeNavItem === 'practice' }"
      @click="setActive('practice')">
      <i class="fas fa-graduation-cap tab-icon"></i>
      <span>练习</span>
    </router-link>
    <router-link to="/progress" class="tab-item" :class="{ active: activeNavItem === 'progress' }"
      @click="setActive('progress')">
      <i class="fas fa-chart-line tab-icon"></i>
      <span>进度</span>
    </router-link>
    <router-link to="/profile" class="tab-item" :class="{ active: activeNavItem === 'profile' }"
      @click="setActive('profile')">
      <i class="fas fa-user tab-icon"></i>
      <span>我的</span>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TabBar',
  computed: {
    ...mapGetters(['getActiveNavItem']),
    activeNavItem() {
      return this.getActiveNavItem
    }
  },
  methods: {
    setActive(navItem) {
      this.$store.dispatch('changeNavItem', navItem)
    }
  }
}
</script>

<style scoped>
.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 83px;
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-top: 1px solid #e5e5e5;
  padding-bottom: 20px;
  z-index: 10;
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
  color: #8e8e93;
  text-decoration: none;
}

.tab-item.active {
  color: #2563eb;
}

.tab-icon {
  font-size: 24px;
  margin-bottom: 4px;
}
</style>